import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './Card.scss';

interface CardProps {
  title?: ReactNode;
  body: ReactNode;
  hidden?: boolean;
  bordered?: boolean;
}

// Updated component with proper typing and scoped styling
const Card = ({ title, body, hidden = false, bordered = false }: CardProps) =>
  !hidden ? (
    <div className={classNames('cardComponent', { cardComponentBordered: bordered })}>
      {title && <div className="cardTitle">{title}</div>}
      <div className="cardBody">{body}</div>
    </div>
  ) : null;

export default Card;
